export default __webpack_public_path__ + "static/banner2-6dc1b8a35f1581041887d850fa9aa3c8.png";